import { render, staticRenderFns } from "./grc-dashboard.vue?vue&type=template&id=239a5c98&scoped=true&"
import script from "./grc-dashboard.vue?vue&type=script&lang=js&"
export * from "./grc-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./grc-dashboard.vue?vue&type=style&index=0&id=239a5c98&scoped=true&lang=css&"
import style1 from "./grc-dashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a5c98",
  null
  
)

export default component.exports